import { WEB_LINKS } from '@/shared/web/type';

export const WEB_ROUTE_PATHS = {
  [WEB_LINKS.HOME]: '/',
  [WEB_LINKS.AUTH]: '/auth',
  [WEB_LINKS.LOGIN]: 'login',
  [WEB_LINKS.MAIN]: 'main',
  [WEB_LINKS.PRODUCTS]: 'products',

  [WEB_LINKS.HISTORY_PAYMENT]: '/history-payment/:name',
  [WEB_LINKS.PAYMENT_DETAIL]: '/history-payment/detail/:id/:operationCode',

  [WEB_LINKS.PAYMENT]: 'payment',
  [WEB_LINKS.PAYMENT_FORM]: '/payment/:form/:id?',

  [WEB_LINKS.SETTINGS]: 'settings',
  [WEB_LINKS.SETTINGS_ACCOUNT_VISIBILITY]: '/settings/account-visibility',
  [WEB_LINKS.SETTINGS_REGULATIONS]: '/settings/regulations',
  [WEB_LINKS.SETTINGS_EMPLOYEE_LIST]: '/settings/employees',
  [WEB_LINKS.SETTINGS_EMPLOYEE_DETAIL]: '/settings/employees/:id',
  [WEB_LINKS.SETTINGS_EMPLOYEE_OUTLET_ACCESS]: '/settings/employees/:id/acceess-outlet',
  [WEB_LINKS.SETTINGS_PASSWORD]: '/settings/password',
  [WEB_LINKS.SETTINGS_PHONE]: '/settings/phone',
  [WEB_LINKS.SETTINGS_API_KEY]: '/settings/api-key',

  [WEB_LINKS.ACCOUNT]: '/account/:id',
  [WEB_LINKS.ACCOUNT_REQ]: '/account-requisites',
  [WEB_LINKS.DOCUMENTS]: '/documents',
  [WEB_LINKS.POS_TERMINAL]: '/pos-terminal/:name',
  [WEB_LINKS.IMPORTED_FILES]: 'imported',
  [WEB_LINKS.IMPORTED_FILE]: '/imported/:id',

  [WEB_LINKS.LOAN_CLAIMS]: '/loan-claims',

  [WEB_LINKS.INSTALLMENT]: '/installment/:name',
  [WEB_LINKS.INSTALLMENT_ONBOARDING]: '/installment/onboarding',
  [WEB_LINKS.INSTALLMENT_DETAIL]: '/installment/detail/:id',

  [WEB_LINKS.CARD]: '/card',
  [WEB_LINKS.CARD_LIMIT]: '/card/limit',
  [WEB_LINKS.CARD_BLOCK]: '/card/block',

  [WEB_LINKS.POS_MAIN]: '/pos',
  [WEB_LINKS.POS_ORDER]: '/pos/order',
  [WEB_LINKS.POS_DETAIL]: '/pos/detail/:id',

  [WEB_LINKS.OUTLET_MAIN]: '/outlet',
  [WEB_LINKS.OUTLET_CREATE]: '/outlet/create',
  [WEB_LINKS.OUTLET_DETAILS]: '/outlet/details/:name',
  [WEB_LINKS.OUTLET_EMPLOYEE_CREATE]: '/outlet/employee/create',
  [WEB_LINKS.OUTLET_EMPLOYEE_DETAILS]: '/outlet/employee/details/:id',
  [WEB_LINKS.OUTLET_CASH_EDIT]: '/outlet/cash/edit',
  [WEB_LINKS.OUTLET_INVITED_CASHIERS]: '/outlet-invoice-cashiers',
  [WEB_LINKS.PERSONAL_QR]: '/outlet/personal-qr',
  [WEB_LINKS.TWO_GIS]: '/two-gis',
  [WEB_LINKS.BANK_OFFICES]: '/bank-offices',

  [WEB_LINKS.EXCHANGE_RATE]: '/exchange-rate',

  [WEB_LINKS.QR_CODE]: '/qr',
  [WEB_LINKS.QR_PAYMENT]: '/qr-payment',

  [WEB_LINKS.BUDGET]: '/budget',
  [WEB_LINKS.BUDGET_PAYMENT_PROCESS]: '/budget/:form/:id?',

  [WEB_LINKS.NPT]: '/npt',

  [WEB_LINKS.SALARY]: '/salary/:name',
  [WEB_LINKS.SALARY_MANUAL]: '/salary/manual/:id?',
  [WEB_LINKS.SALARY_STATEMENT_DETAIL]: '/salary/detail/:id',
  [WEB_LINKS.SALARY_STATEMENT_DETAIL_PROCESSING_FILE]: '/salary/detail-processing/:id',

  [WEB_LINKS.INVOICE]: '/invoice',
  [WEB_LINKS.INVOICE_DETAIL]: '/invoice/detail',
  [WEB_LINKS.INVOICE_LEGAL]: '/invoice/legal',
  [WEB_LINKS.INVOICE_INDIVIDUAL]: '/invoice/individual/:id?',

  [WEB_LINKS.APPROVE]: '/approve',
  [WEB_LINKS.NOTIFICATION]: '/notification',

  [WEB_LINKS.LETTER]: '/letter/:name/:id?',
  [WEB_LINKS.LETTER_CREATE]: '/letter-create',
  [WEB_LINKS.LETTER_DETAIL]: '/letter-detail/:id/:tab',
};
